/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Funnel_Section_ProviderInputs */

const en_admin_funnel_section_provider = /** @type {(inputs: Admin_Funnel_Section_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`By payment provider`)
};

/**
* | output |
* | --- |
* | "By payment provider" |
*
* @param {Admin_Funnel_Section_ProviderInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_funnel_section_provider = /** @type {((inputs?: Admin_Funnel_Section_ProviderInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Funnel_Section_ProviderInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_funnel_section_provider(inputs)
});
export { admin_funnel_section_provider as "admin.funnel.section.provider" }